import { render, staticRenderFns } from "./ModalBrandme.vue?vue&type=template&id=5df03373&"
import script from "./ModalBrandme.vue?vue&type=script&lang=js&"
export * from "./ModalBrandme.vue?vue&type=script&lang=js&"
import style0 from "./ModalBrandme.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports